import Axios from 'axios';
import store from '@/store';

export const getAllNotifications = () =>
  Axios.post('notification/getAllNotification', {
    UserId: store.getters['authentication/getUserProfile'].sub,
    Skip: 0,
    Take: 10
  });

export const makeReadNotifications = ids => Axios.post('notification/markReadNotification', {
  id: ids,
  userId: store.getters['authentication/getUserProfile'].sub
});

export const disableNotification = id => Axios.post('notification/disableNotification', {
  id_Notification: id,
  id_User: store.getters['authentication/getUserProfile'].sub
});

export const getAllNotificationsByUser = () => Axios.get('notification/getAllNotificationByUser');
